import { Component, OnInit } from '@angular/core';

import { BDUtilityService } from '@brother-apps/brother-dealerapp-shared-lib';
import { ContactService } from '../services/contact.service';
import { IContact } from '../interfaces/contact.interface';
import { UserContextService } from '../../../core/services/user-context.service';
import {UserDetailsModel} from '../../auth/models/user-details-model';

@Component({
    selector: 'contact-widget',
    templateUrl: './contact-widget.component.html',
    styleUrls: ['./contact-widget.component.scss']
})

export class ContactWidgetComponent implements OnInit {

    public isContactOpen = false;
    public contact: IContact = null;

    constructor(
        private userContextService: UserContextService,
        private contactService: ContactService,
        private utilityService: BDUtilityService
    ) { }

    ngOnInit() {
        console.log('ContactWidgetComponent init');
    }

    async openContactWidget(): Promise<void> {
        this.isContactOpen = !this.isContactOpen;
        if (this.isContactOpen) {
            const relatedContactEmail: string = this.userContextService.getRelatedContactEmail();
            this.contact = await this.contactService.get(this.userContextService.getUserId(), relatedContactEmail);
        }
    }

    requestCallback(): string {
        const userDetails: UserDetailsModel = this.userContextService.getUserDetails() || {} as UserDetailsModel;
        return this.utilityService.requestCallback(
            userDetails.lastName,
            userDetails.firstName,
            userDetails.email,
            userDetails.salutation,
            this.userContextService.getRelatedContactEmail()
        );
    }

}
